import { request } from '@/api/request';
import type { Connection } from '@@/packages/shared/types/models/connection';
import type { MergeRequest } from '@@/packages/shared/types/models/mergeRequest';

type FullInvite = {
  id: string;
  senderName: string;
  recipientOrgName: string;
  recipientEmail: string;
  createdAt: string;
  expired: boolean;
  expiresAt?: string;
  accepted: boolean;
  acceptedAt?: string;
  acceptedByOrgID?: string;
  acceptedByOrgLogo?: string;
  resentAt?: string;
  cancelled: boolean;
  cancelledAt?: string;
  unclaimedOrgID: string;
};

type InvitesResponse = {
  invites: FullInvite[];
  metadata: {
    limit: number;
    offset: number;
    total: number;
    name: string;
    sort: string;
    sentBy: string;
    sortDirection: string;
  };
};

export const getInvites = (status: string, meta: Partial<InvitesResponse['metadata']>) =>
  request<InvitesResponse>('GET', '/invites', null, {
    status,
    limit: meta.limit,
    offset: meta.offset,
    name: meta.name,
    sort: meta.sort,
    sentBy: meta.sentBy,
    sortDirection: meta.sortDirection,
  });

export const getInvitesCounts = () => request('GET', '/invites/counts');

export const resendInvite = (inviteID: string) => request('POST', `/invites/${inviteID}/resend`);

export const cancelInvite = (inviteID: string) => request('POST', `/invites/${inviteID}/cancel`);

export const getInviteInfo = (inviteID: string) => request('GET', `/invites/${inviteID}`);

type RedeemInviteResponse = {
  mergeRequest?: MergeRequest;
  connection: Connection;
};

export const redeemInvite = (inviteID: string) =>
  request<RedeemInviteResponse>('POST', `/invites/${inviteID}/redeem`);
